module.exports = __webpack_public_path__ + "static/media/SDT-G2-Roof-Top.335cc067.png";